<template>
  <div id="login-main">
    <v-card class="mx-auto my-12" max-width="374">
      <v-card-text>
        <div>
          <v-text-field id="admin-username" v-model="inputUsername" label="Username" autocomplete="username"></v-text-field>
        </div>
        <div>
          <v-text-field id="admin-password" label="Password" v-model="inputPassword" type="password" autocomplete="current-password"></v-text-field>
        </div>
        <div>
          <v-btn @click="check">Accedi</v-btn>
        </div>
        <div role="alert" aria-live="assertive" v-if="error">
          Credenziali errate
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      inputUsername: "",
      inputPassword: "",
      username: "admin",
      password: "mySpecial123",
      error:false
    };
  },
  watch: {
    inputUsername:function() {

    }
  },
  methods: {
    check() {
      if (
        this.username == this.inputUsername &&
        this.password == this.inputPassword
      ) {
        this.$store.commit("cardLogged", true);
        this.$emit("loginaction",true);
      } else {
        this.error = true;
        setTimeout(p=>{this.error = false},2000)
      }
    },
  },
};
</script>

<style>
</style>